import React from 'react';
import DisplayUsernameMessages from './DisplayUsernameMessages';
import DeleteAccount from './DeleteAccount';
import Avatar from './Avatar';

function Account() {
  return (
    <div className="text-text-primary flex flex-col gap-3 p-1 text-sm">
      <div className="bordered-item">
        <Avatar />
      </div>
      <div className="bordered-item">
        <DeleteAccount />
      </div>
      <div className="bordered-item">
        <DisplayUsernameMessages />
      </div>
    </div>
  );
}

export default React.memo(Account);
